import styled from 'styled-components';

const DescriptionWrapper = styled.div `
  width: 50%;
  margin-bottom: ${({ theme }) => theme.olist.spacing.stack.large};

  @media (max-width: ${({ theme }) => theme.olist.breakpoints.small}) {
    width: 100%;
  }
`;

export { DescriptionWrapper };
